import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { createGlobalStyle } from 'styled-components';

export interface PopoverGlobalStylesProps {
  closeTimeoutMS: number;
  contentClassNames: ReactModal.Classes;
  overlayClassNames: ReactModal.Classes;
}

const { spacing } = theme;

export const PopoverGlobalStyles = ({
  closeTimeoutMS,
  contentClassNames,
  overlayClassNames,
}: PopoverGlobalStylesProps) => createGlobalStyle`
  .${overlayClassNames.base} {
    position: fixed;
    z-index: 200;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  
  }

  .${contentClassNames.base} {
    position: absolute;
    background: var(--neutral-white-base);
    padding: ${spacing.lg}px ${spacing.xl}px;
    transition: opacity ${closeTimeoutMS}ms ease ${closeTimeoutMS}ms;
    opacity: 0;
    border-radius: ${pxToRem(10)};
    box-shadow: 0 0 ${pxToRem(8)} ${pxToRem(3)} rgba(0, 0, 0, 0.2);
  }

  .${contentClassNames.afterOpen} {
    opacity: 1;
  }

  .${contentClassNames.beforeClose} {
    opacity: 0;
    transition-delay: 0s;
  }
`;
